export default "__VITE_ASSET__IzVJLiYK__"